var _circle, _path, _mask, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRedCheck(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 20,
    r: 20,
    fill: "#EB5757"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.4141 19.9998L27.7071 13.7068C28.0981 13.3158 28.0981 12.6838 27.7071 12.2928C27.3161 11.9018 26.6841 11.9018 26.2931 12.2928L20.0001 18.5858L13.7071 12.2928C13.3161 11.9018 12.6841 11.9018 12.2931 12.2928C11.9021 12.6838 11.9021 13.3158 12.2931 13.7068L18.5861 19.9998L12.2931 26.2928C11.9021 26.6838 11.9021 27.3158 12.2931 27.7068C12.4881 27.9018 12.7441 27.9998 13.0001 27.9998C13.2561 27.9998 13.5121 27.9018 13.7071 27.7068L20.0001 21.4138L26.2931 27.7068C26.4881 27.9018 26.7441 27.9998 27.0001 27.9998C27.2561 27.9998 27.5121 27.9018 27.7071 27.7068C28.0981 27.3158 28.0981 26.6838 27.7071 26.2928L21.4141 19.9998Z",
    fill: "#F2F2F2"
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "mask0",
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse",
    x: 11,
    y: 11,
    width: 18,
    height: 17
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.4141 19.9998L27.7071 13.7068C28.0981 13.3158 28.0981 12.6838 27.7071 12.2928C27.3161 11.9018 26.6841 11.9018 26.2931 12.2928L20.0001 18.5858L13.7071 12.2928C13.3161 11.9018 12.6841 11.9018 12.2931 12.2928C11.9021 12.6838 11.9021 13.3158 12.2931 13.7068L18.5861 19.9998L12.2931 26.2928C11.9021 26.6838 11.9021 27.3158 12.2931 27.7068C12.4881 27.9018 12.7441 27.9998 13.0001 27.9998C13.2561 27.9998 13.5121 27.9018 13.7071 27.7068L20.0001 21.4138L26.2931 27.7068C26.4881 27.9018 26.7441 27.9998 27.0001 27.9998C27.2561 27.9998 27.5121 27.9018 27.7071 27.7068C28.0981 27.3158 28.0981 26.6838 27.7071 26.2928L21.4141 19.9998Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRedCheck);
export default __webpack_public_path__ + "static/media/red-check.76c3911c.svg";
export { ForwardRef as ReactComponent };